import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import './plugins/layui.js'
// import '../public/js/xlsx.full.min.js'
// 屏幕自适应（html zoom 等比缩放，须最先执行，避免首屏闪烁）
import './plugins/adaptive'
// 修复 zoom 缩放导致 Element UI 弹层（下拉/悬浮菜单等）定位偏移（须在 adaptive 之后）
import './plugins/fix-popper'
import './plugins/rem'

// 导入字体图标
import './assets/fonts/iconfont.css'
// 导入全局样式表
import './assets/css/global.css'
// 导入 Element UI 统一样式覆盖（需在 global.css 之后引入，保证覆盖优先级）
import './assets/css/element-override.css'
// 导入主题配置（颜色/字号等全局 CSS 变量）
import { applyTheme } from './config/theme'
import TreeTable from 'vue-table-with-tree-grid'

// 导入富文本编辑器
// import VueQuillEditor from 'vue-quill-editor'
// // require styles 导入富文本编辑器对应的样式
// import 'quill/dist/quill.core.css' // import styles
// import 'quill/dist/quill.snow.css' // for snow theme
// import 'quill/dist/quill.bubble.css' // for bubble theme

// 导入nprogress 包对应的js和css
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import md5 from 'js-md5'
import axios from 'axios'
import store from './store'
import echarts from 'echarts'
import Http from './service/http'
import Http1 from './service/http1'
import Http2 from './service/http2'
import directives from './plugins/directives.js'
import vueEsign from 'vue-esign'
import 'swiper/css/swiper.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import utils from './plugins/util'; //获取url参数
import htmlToPdf from './plugins/htmlToPdf.js'
import vueSeamlessScroll from 'vue-seamless-scroll'
import infiniteScroll from "vue-infinite-scroll";
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';

Vue.use(VueAwesomeSwiper)
Vue.use(vueEsign)
Vue.use(directives)
Vue.use(htmlToPdf)
Vue.use(vueSeamlessScroll)
Vue.use(preview)// 图片点击大图预览

Vue.prototype.axios = axios;
Vue.prototype.$Http2=Http2
Vue.prototype.$Http1=Http1
Vue.prototype.$Http=Http
Vue.prototype.$utils = utils; //注册全局方法
Vue.use(infiniteScroll);
// 配置请求的跟路径
if (window.sessionStorage.getItem('baseURL')) {
  axios.defaults.baseURL = window.sessionStorage.getItem('baseURL')
}
if (window.sessionStorage.getItem('wsuri')) {
  axios.defaults.wsuri = window.sessionStorage.getItem('wsuri')
}
axios.defaults.baseURL = process.env.VUE_APP_LOGIN_BASE
// axios.defaults.baseURL = ''
// axios.defaults.wsuri = ''
// 在request拦截器中 展示进度条NProgress.start()

axios.interceptors.request.use(config => {
  // console.log(config)
  NProgress.start()
  config.headers.Authorization = 'Bearer' + window.sessionStorage.getItem('token')
  // 在最后必须 return config
  return config
})
// 在response拦截器中,隐藏进度条NProgress.done()
axios.interceptors.response.use(config => {
  NProgress.done()
  return config
})
Vue.prototype.$http = axios
Vue.prototype.$store = store

Vue.config.productionTip = false

Vue.component('tree-table', TreeTable)
// 将富文本编辑器,注册为全局可用的组件
// Vue.use(VueQuillEditor)
Vue.prototype.$echarts = echarts
// 加''是将数据转成字符串
// md5加密
Vue.prototype.$md5 = md5
// padStart 不足两位 前加0
Vue.filter('dateFormat', function(originVal) {
  const dt = new Date(originVal)

  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')

  const hh = (dt.getHours() + '').padStart(2, '0')
  const mm = (dt.getMinutes() + '').padStart(2, '0')
  const ss = (dt.getSeconds() + '').padStart(2, '0')

  return `${y}-${m}-${d} ${hh}:${mm}`
})
// Vue.formatterDate(row, column, cellValue, index) {
//   if (cellValue == null || cellValue == '') {
//     return false
//   } else {
//     var dateee = new Date(cellValue).toJSON()
//     let str = new Date(+new Date(dateee) + 8 * 3600 * 1000)
//       .toISOString()
//       .replace(/T/g, ' ')
//       .replace(/\.[\d]{3}Z/, '')
//     return str
//   }
// }
// 时间格式化
Vue.prototype.formatterDate = function (row, column, cellValue, index) {
  if (cellValue == null || cellValue == '') {
    return false
  } else {
    var dateee = new Date(cellValue).toJSON()
    let str = new Date(+new Date(dateee) + 8 * 3600 * 1000)
      .toISOString()
      .replace(/T/g, ' ')
      .replace(/\.[\d]{3}Z/, '')
    return str
  }
}

//正序排列
Vue.prototype.sortKey= function(array,key){
  return array.sort(function(a,b){
    var x=a[key];
    var y=b[key];
    return ((x<y)?-1:(x>y)?1:0)
  })
}
///获取月份的最后一天:如'2025-07'
Vue.prototype.$getMonthLastDay= function(s){
  let ss=s.substr(5,7)
  let sss=parseInt(ss)+1
  sss=sss<10?('0'+sss):sss
  let ndate=s.substr(0,5)+sss+'-01'
  console.log(ndate,'---新日期')
  let date=new Date(ndate)
  let string1=date.getTime()
  let aa=1000*60*60*24
  let string2=string1-aa
  let lastday=new Date(string2)
  let year=lastday.getFullYear()
  let month=lastday.getMonth()+1
  month=month<10?('0'+month):month
  let day=lastday.getDate()
  day=day<10?('0'+day):day
  return year+'-'+month+'-'+day
}
// 应用主题（将配置写入 CSS 变量，合并用户自定义项）
applyTheme()

// 文件获取
new Vue({
  axios,
  store,
  router,
  render: h => h(App)
}).$mount('#app')
